import {
    addBrandToTeamFail,
    addBrandToTeamSuccess,
    addJurisdictionToTeamFail,
    addJurisdictionToTeamSuccess,
    deleteBrandFromTeamFail,
    deleteBrandFromTeamSuccess,
    deleteJurisdictionFromTeamFail,
    deleteJurisdictionFromTeamSuccess
} from './actions';
import { put, select } from 'redux-saga/effects';
import {
    makeErrorPayload,
    makeSuccessPayload
} from '../../../../../../shared/helpers/payload.helper';
import {
    setErrorToast,
    setSuccessToast
} from '../../../../../../shared/toast/redux/actions';
import {
    addBrandToTeam,
    updateTeamJurisdictions,
    deleteBrandFromTeam,
    deleteJurisdictionFromTeam
} from '../team.backend';
import {
    fetchTeamDetails,
    fetchTeamDetailsSuccess
} from '../team-details/actions';
import { getBrandsAndJurisdictions } from '../../../../../../jurisdiction/redux/selectors';

export function* addJurisdictionToTeamSaga(action) {
    const { teamId, jurisdictions } = action.payload;
    const { brands } = yield select(getBrandsAndJurisdictions);

    try {
        const response = yield updateTeamJurisdictions(teamId, {
            jurisdictions
        });
        yield put(addJurisdictionToTeamSuccess(response.data));
        yield put(setSuccessToast(makeSuccessPayload('Jurisdictions added.')));
        yield put(
            fetchTeamDetailsSuccess(
                makeTeamDetailsWithBrandIds(response.data, brands)
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(addJurisdictionToTeamFail(formattedError));
        yield put(fetchTeamDetails(teamId));
        yield put(setErrorToast(formattedError));
    }
}

export function* deleteJurisdictionFromTeamSaga(action) {
    const { teamId, jurisdictionCode } = action.payload;
    const { brands } = yield select(getBrandsAndJurisdictions);
    try {
        const response = yield deleteJurisdictionFromTeam(
            teamId,
            jurisdictionCode
        );
        yield put(deleteJurisdictionFromTeamSuccess(response.data));
        yield put(setSuccessToast(makeSuccessPayload('Jurisdiction deleted.')));
        yield put(
            fetchTeamDetailsSuccess(
                makeTeamDetailsWithBrandIds(response.data, brands)
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(deleteJurisdictionFromTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* addBrandToTeamSaga(action) {
    const { teamId, jurisdictionCode, brandId } = action.payload;
    const { brands } = yield select(getBrandsAndJurisdictions);
    try {
        const response = yield addBrandToTeam(teamId, jurisdictionCode, {
            id: brandId
        });
        yield put(addBrandToTeamSuccess(response.data));
        yield put(setSuccessToast(makeSuccessPayload('Brands added.')));
        yield put(
            fetchTeamDetailsSuccess(
                makeTeamDetailsWithBrandIds(response.data, brands)
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(addBrandToTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* deleteBrandFromTeamSaga(action) {
    const { teamId, jurisdictionCode, brandId } = action.payload;
    const { brands } = yield select(getBrandsAndJurisdictions);
    try {
        const response = yield deleteBrandFromTeam(
            teamId,
            jurisdictionCode,
            brandId
        );
        yield put(deleteBrandFromTeamSuccess(response.data));
        yield put(setSuccessToast(makeSuccessPayload('Brand deleted.')));
        yield put(
            fetchTeamDetailsSuccess(
                makeTeamDetailsWithBrandIds(response.data, brands)
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(deleteBrandFromTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export const makeTeamDetailsWithBrandIds = (data, brands) => ({
    ...data,
    jurisdictions: (data.jurisdictions || []).map(({ code, brandIds }) => ({
        code,
        brandIds:
            brandIds && brandIds.length
                ? brandIds
                : brands
                      .filter(brand => brand.jurisdiction === code)
                      .map(brand => brand.id)
    }))
});
